<template>
  <v-app id="inspire">
    <v-progress-circular
      indeterminate
      color="green"
      v-if="this.loader"
      style="margin-left: 10px;"
    />
    <span v-else>
      <v-navigation-drawer
        class="hideOnPagePrint"
        v-if="this.isLoggedIn"
        permanent
        app
        :mini-variant="true&&(this.getGlobalValue('VEC_ADMIN_SIDEBAR_MINI')=='true'||true)"
      >
        <v-list dense>
          <template v-for="item in this.menuItems">
            <v-tooltip :key="item.id" right open-on-hover open-delay="400">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-row
                    v-if="item.heading"
                    :key="item.heading"
                  >
                    <v-col cols="6">
                      <v-subheader v-if="item.heading" style='color: white!important;'>
                        {{ item.heading }}
                      </v-subheader>
                    </v-col>
                    <v-col
                      cols="6"
                      class="text-center"
                    >
                      <a
                        href="#!"
                        class="body-2 black--text"
                      >EDIT</a>
                    </v-col>
                  </v-row>
                  <v-list-group
                    v-else-if="item.children"
                    :key="item.text"
                    v-model="item.model"
                    :prepend-icon="item.model ? item.icon : item['icon-alt']"
                    append-icon=""
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.text }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item
                      v-for="(child, i) in item.children"
                      :key="i"
                      link
                      :to="item.path"
                    >
                      <v-list-item-action v-if="child.icon">
                        <v-icon>{{ child.icon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ child.text }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                  <v-list-item
                    v-else
                    :key="item.text"
                    link
                    :to="item.path"
                  >
                    <v-list-item-action>
                      <v-icon :color="getGlobalValue('VEC_ADMIN_SIDENAV_ICON_COLOR')||''">{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </span>
              </template>
              <span>{{item.text}}</span>
            </v-tooltip>
          </template>
        </v-list>
      </v-navigation-drawer>
      <v-main v-if="!loader">
        <div  v-if="this.isLoggedIn" style="width: 100%; background-color: rgba(0,0,0,0.5); padding: 10px;" class="d-flex flex-row align-center justify-space-between">
          {{this.getGreeting()}}
          <span v-if="this.getGlobalValue('ADMIN_APPLICATION_BANNER_MESSAGE')" style="margin-top: 7px;" >{{getGlobalValue('ADMIN_APPLICATION_BANNER_MESSAGE') }}</span>
          <v-btn @click="logoutA" color="success" x-small fab><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-container
          class="fill-height"
          style="justify-content: flex-start; align-items: flex-start; padding: 30px; background-color: rgba(200,200,0,0.1); min-height: 100vh;"
          fluid
        >
          <router-view/>
          <!-- <v-snackbar v-model="getSnack" :timeout="3000" color="">
            {{ getSnackText }}
            <template v-slot:action="{ attrs }">
              <v-btn v-bind="attrs" text @click="setSnack({snack: false})">Close</v-btn>
            </template>
          </v-snackbar> -->
          <v-dialog
            v-model="this.queryDialog.isOpen"
            width="500"
          >
            <v-card style="overflow-y:hidden">
              <v-card-title class="text-h5 d-flex flex-column align-center justify-center">
                <v-progress-circular
                  indeterminate
                  color="green"
                  v-if="queryDialog.loader"
                  style="margin-top: 20px; margin-bottom: 10px;"
                ></v-progress-circular>
                <b>{{queryDialog.text}}</b>
                <!-- <v-text-field style="opacity: 1; height: 1px;" :autofocus=true v-model="queryDialogTerm" @change="loadJob()" outlined></v-text-field> -->
              </v-card-title>
              <v-card-actions>
                <v-btn color="primary" text @click="closeQueryDialog()">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
        <v-dialog
          v-model="logoutDialog"
          width="500"
        >
          <v-card>
            <v-card-title>Confirm Logout</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="logoutB()"
              >
                Logout
              </v-btn>
              <v-btn
                color="primary"
                text
                @click="logoutDialog = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-main>
    </span>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </v-app>
</template>
<style>
.v-snack__wrapper {
  max-width: none;
}
</style>
<script>
  import { mapGetters, mapMutations } from "vuex"
  import scanSystem from "./plugins/scanSystem"
  import axios from 'axios'
  export default {
    props: {
      source: String,
    },
    data: () => ({
      snackObj: {
        color: '',
        text: ''
      },
      dialog: false,
      drawer: null,
      loader: true,
      queryDialog: {
        isOpen: false,
        loader: false,
        term: '',
        text: 'Awaiting your scan...',
      },
      scanString: '',
      logoutDialog: false,
    }),
    watch: {
      $route (to, from){
        if(from.name==="Login"&& to.name!=="Home"){
          this.unlockScanBus()
          this.resetScanBus()
        }
        if(from.name==="Home"){
          this.resetScanBus()
        }
      }
    },
    async mounted(){
      try {
        await this.reloadApplication()
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    computed: {
      ...mapGetters(["getUser",
        'getId',
        'isLoggedIn',
        'getPerms',
        'globalQueryBcAllowed',
        'getEndpoint',
        'isAllowed',
        'scanBus',
        'menuItems',
        'getGlobalValue'
      ])
    },
    methods: {
      ...mapMutations([
        'logout',
        'setPerms',
        'setUser',
        'setEndpoint',
        'setUserCache',
        'lockGlobalQueryBc',
        'unlockGlobalQueryBc',
        'setScanBusData',
        'setScanBusType',
        'resetScanBus',
          'setGLOBALS'
      ]),
      async reloadApplication(){
        try {
          this.loader = true
          // very important: determine what is the origin
          let origin = window.location.origin;
          if(origin == "https://judys.cloud"){
            this.setEndpoint(process.env.VUE_APP_CLOUD)
            console.log(`Origin: ${origin} | Endpoint Set: ${this.getEndpoint}`)
          }else if(origin == "http://admin.judys.vims"){
            this.setEndpoint(process.env.VUE_APP_PREM)
            console.log(`Origin: ${origin} | Endpoint Set: ${this.getEndpoint}`)
          }else if(origin.includes("http://localhost")){
            this.setEndpoint(process.env.VUE_APP_LOCALHOST)
            console.log(`Origin: ${origin} | Endpoint Set: ${this.getEndpoint}`)
          }else if(origin.includes("http://11.111.111.11")){
            this.setEndpoint(process.env.VUE_APP_PUBLIC)
            console.log(`Origin: ${origin} | Endpoint Set: ${this.getEndpoint}`)
          }else{
            this.setEndpoint(process.env.VUE_APP_EPHEMERAL)
            console.log(`Origin: ${origin} | Endpoint Set: ${this.getEndpoint}`)
          }

          if(!this.isLoggedIn) throw "User not logged in."

          this.setGLOBALS((await axios.get(`${this.getEndpoint}/api/globals`)).data.data)

          if(!this.getUser){
            let user = await axios.get(`${this.getEndpoint}/api/users/protected/${this.getId}`)
            if(!user.data.error) this.setUser(user.data)
            console.log("✅ User loaded.")
          }

          if(this.getPerms==null){
            let perms = await axios.get(`${this.getEndpoint}/getPerms`)
            if(!perms.data.error) this.setPerms(perms.data)
          }


          let userNames = await axios.get(`${this.getEndpoint}/api/users/userNames`)
          if(userNames.data.success){
            this.setUserCache(userNames.data.data)
            console.log("✅ Users cache loaded.")
          }
          else throw "❌ Users cache not loaded. Please retry."

          //Barcode Daemon
          //Barcode and Shortcut Daemon
          console.log('APP.JS: ✅ Scan Sense Active.')
          window.addEventListener('keypress', (e)=>{ // keys will always be pressed,
            if(this.isLoggedIn && !this.scanBus.locked){ //to use barcode services an invoker must be logged in and the scanbus cannot be locked
              this.cancelClearScanStringTimeout()
              this.clearScanStringTimeout()
              if(this.keyShortcutMode){
                this.cancelClearScanStringTimeout()
                if(e.key==='/'){
                  this.endShortcut()
                }else{
                  if(e.key==='Enter'){
                    console.log(this.scanString)
                    this.handleShortcut(this.scanString)
                  }else{
                    if(!this.scanString) this.scanString = ""
                    this.scanString = this.scanString + e.key
                  }
                }
              }else{
                if(e.key==='/'){
                  if(!this.scanString){
                    this.cancelClearScanStringTimeout()
                    this.keyShortcutMode = true
                  }else{
                    this.scanString = this.scanString + e.key
                  }
                }else{
                  if(e.key==='Enter'){
                    let validatedType = scanSystem.validateType(this.scanString)
                    if(validatedType){
                      if(this.scanBus.type !== 'out' && this.scanBus.type !== 'in' && this.scanBus.type !== 'customer' && this.scanBus.type !== 'authorization'){
                        this.setScanBusType(validatedType)
                      }
                      this.scanInProgress = true
                      this.handleScan(this.scanBus.type)
                      this.clearScanString()
                    }else{
                      this.clearScanString()
                      this.resetScanBus()
                    } 
                  }else{
                    this.scanInProgress = false
                    if(!this.scanString) this.scanString = ""
                    this.scanString = this.scanString + e.key
                  }
                }
              }
            }
          })
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false
        } 
      },
      logoutA(){
        this.logoutDialog = true
      },
      logoutB(){
        console.log("Logout")
        this.logoutDialog = false
        this.$router.push({path: "/logout"})
      },
      openQueryDialog(){
        this.queryDialog.text = 'Product Scan Initiated'
        this.queryDialog.isOpen = true
        this.queryDialog.loader = true;
      },
      closeQueryDialog(){
        this.queryDialog.text = 'Awaiting your scan...'
        this.queryDialog.isOpen = false
        this.queryDialog.loader = false;
      },
      async loadJob(){
        this.setScanBusData(this.scanString)
        let pId = (this.scanBus.data.replace("J-", ''));
        console.log(pId)
        await this.$router.push({path: `/jobs?selected=${pId}`})
      },
      addJobToBulkOperation(){
        let pId = (this.scanBus.data.replace("J-", ''));
        console.log("ADD"+ pId + " to job.")
      },
      clearScanString(){
        this.scanString = ''
        console.log("🔁 Scan String Cleared")
      },
      clearScanStringTimeout(){
        this.timeout = setTimeout(this.clearScanString,500)
      },
      cancelClearScanStringTimeout(){
        clearTimeout(this.timeout)
      },
      async handleScan(type){
        try {
          let s = this.scanString.replace(/\\\/\/\\=/,'')
          let pId = (s.replace(`${type}-`, ''));
          let p,x;
          pId
          switch(type){
            case 'VSID':
              // this.setScanBusData({username: this.lookupUsername(pId.split("-")[0]), uId: pId.split("-")[0]})
              // console.log(this.lookupUsername(pId.split("-")[0]))
              p = '/users/view/'+pId.split("-")[0]
              if(this.$route.path!==p)
                await this.$router.push({path: p})
              this.scanInProgress = false
              break
            case 'J':
              console.log("Job Ticket Scanned: ", s)
              p = `/jobs?selected=${s.split('-')[1]}`
              if(this.$route.path!==p)
                await this.$router.push({path: p})
              this.scanInProgress = false
              break;
            case "out":
            case "in":
            case "customer":
              console.log(`Job Ticket Scanned for bulk ${type} operation: `, s)
              x = [];
              if(scanSystem.validateType(this.scanString)==='J'){
                pId = (s.replace("J-", ''));
                if(!this.scanBus.data) this.setScanBusData(x)
                if((this.scanBus.data.filter(x=>x.job.id==pId)).length < 1){ // this means the job was already scanned
                  x = this.scanBus.data
                  let res = await axios.get(`${this.getEndpoint}/api/jobs/check/${type}/${pId}`)
                  if(res.data.success){
                    x.push({job: res.data.job, ok: true})
                    this.setScanBusData(x)
                  }else{
                    x.push({job: res.data.job, ok: false, reason: res.data.message})
                    this.setScanBusData(x)
                  }
                }else{
                  console.log("Job Already Scanned.")
                  this.snack("Item Already Scanned")
                }
              }
              break
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
          this.scanInProgress = false
        }
      },
      toBase36(n) {
        if (n === 0) {
          return '0';
        }
        var digits = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var result = ''; 
        while (n > 0) {
          result = digits[n % digits.length] + result;
          n = parseInt(n / digits.length, 10);
        }
      
        return result;
      },
      fromBase36(s) {
        var digits = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var result = 0;
        for (var i=0 ; i<s.length ; i++) {
          var p = digits.indexOf(s[i]);
          if (p < 0) {
            return NaN;
          }
          result += p * Math.pow(digits.length, s.length - i - 1);
        }
        return result;
      },
      getGreeting(){
        if(this.getUser != null && this.getUser != undefined){
          let d = new Date().getHours()
          let h = ''
          if(d >= 0 && d < 11) h = 'Morning'
          if(d >= 11 && d < 14) h = 'Day'
          if(d >= 14 && d < 17) h = 'Afternoon'
          if(d >= 17 && d < 19) h = 'Evening'
          if(d >= 19 && d <= 23) h = 'Night'
          return 'Good ' + h + ', ' + this.getUser.firstName.split(" ")[0] + '!'
        }
      },
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
    },
  }
</script>